import { User } from "../../model/User";

export const isTokenValid = (user?: User) => {
  return user && 1000 * user.tokenExpiresAt > new Date().getTime();
};
